import { render, staticRenderFns } from "./SelectPublisher.vue?vue&type=template&id=6ec785e6&lang=pug&"
import script from "./SelectPublisher.vue?vue&type=script&lang=js&"
export * from "./SelectPublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports